import { BASE_URL } from 'config';
import React, { useState, useEffect } from "react";
import {
  Box,
  TextField,
  Select,
  MenuItem,
  Button,
  Avatar,
  Typography,
  FormControl,
  FormHelperText,
  InputLabel,
  Grid,
  Divider,
  Input,
  IconButton,
} from "@mui/material";
import inputLabel from "assets/theme/components/form/inputLabel";
import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import { validateEmail, validateRequired, validatePasswordMatch } from "validations";
import axios from "axios";
import Swal from "sweetalert2";
import avatar from "assets/theme/components/avatar";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const AddBrandForm = ({ onClose, onSuccess, initialData }) => {
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  const [formData, setFormData] = useState({
    name: initialData?.name || "",
    keywords: initialData?.keywords || "",
    slug: initialData?.slug || "",
    meta_title: initialData?.meta_title || "",
    meta_icon: initialData?.image || null,
    image: null,
    banner: null,
    description: initialData?.description || "",
    id: initialData?.id || null, // Add ID field
  });

  // Add useEffect to handle initial data
  useEffect(() => {
    if (initialData) {
      setFormData({
        name: initialData.name,
        keywords: initialData.keywords,
        slug: initialData.slug,
        meta_title: initialData.meta_title,
        meta_icon: initialData.meta_icon,
        image: initialData.image,
        banner: initialData.banner,
        description: initialData?.description || "",
        id: initialData.id, // Add ID field
      });
      console.log("this is the image:", formData.image);
    }
  }, [initialData]);
  const [errors, setErrors] = useState({});
  const [formSubmitted, setFormSubmitted] = useState(false);

  useEffect(() => {
    if (formSubmitted) validateForm();
  }, [formData]);

  const validateForm = () => {
    const newErrors = {};

    if (!validateRequired(formData.name)) newErrors.name = "يجب إدخال الاسم";
    if (!formData.image) newErrors.image = "يجب اختيار صورة الفئة";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    const fieldName = e.target.name;

    const allowedTypes = ["image/png", "image/jpeg", "image/jpg", "image/gif"];

    // إذا لم يتم رفع ملف
    if (!file) {
      if (fieldName === "image") {
        setFormData((prev) => ({ ...prev, image: null }));
        setErrors((prev) => ({
          ...prev,
          image: "يجب اختيار صورة الفئة",
        }));
      }
      return;
    }

    // إذا كان نوع الملف غير مدعوم
    if (!allowedTypes.includes(file.type)) {
      setErrors((prev) => ({
        ...prev,
        [fieldName]: "يجب أن تكون الصورة بصيغة PNG أو JPG أو JPEG أو GIF فقط",
      }));
      setFormData((prev) => ({ ...prev, [fieldName]: null }));
      return;
    }

    // في حال كانت الصورة صالحة
    setFormData((prev) => ({ ...prev, [fieldName]: file }));
    setErrors((prev) => ({ ...prev, [fieldName]: "" }));
  };
  // creating new brand
  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    if (!validateForm()) return;
    try {
      const formPayload = new FormData();
      // Append all form data including files
      Object.entries(formData).forEach(([key, value]) => {
        if (value !== null && value !== undefined && key !== "id") {
          // Handle avatar differently for existing vs new
          if (key === "image" || key === "meta_icon" || key === "banner") {
            // Only append new files, keep existing path if no new file
            if (value instanceof File) {
              formPayload.append(key, value);
            }
          } else {
            formPayload.append(key, value);
          }
        }
      });
      // Show loading indicator
      Swal.fire({
        title: "جاري الحفظ...",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
      console.log("Sending payload:", formPayload); // طباعة البيانات المرسلة
      const token = localStorage.getItem("user-token");
      const endpoint = formData.id
        ? `${BASE_URL}/administrator/brands/update/${formData.id}`
        : BASE_URL + "/administrator/brands/store";

      const response = await axios.post(endpoint, formPayload, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      // طباعة تفاصيل الرد
      console.log("Full Response:", response);
      console.log("Response Data:", response.data);
      console.log("Status Code:", response.status);
      // Close loading indicator
      Swal.close();
      if (response.data.status) {
        await Swal.fire({
          icon: "success",
          title: "تم الحفظ!",
          text: "تم حفظ البيانات بنجاح",
          confirmButtonText: "موافق",
          didOpen: () => {
            const container = document.querySelector(".swal2-container");
            container.style.zIndex = "99999";
          },
        });
        onSuccess();
        onClose();
      } else {
        throw new Error(response.data.message || "حدث خطأ غير متوقع");
      }
    } catch (error) {
      Swal.close();
      console.error("Error Details:", error);
      console.log("Error Response:", error.response?.data);
      const errorMessage = error.response?.data?.message || error.message || "حدث خطأ أثناء  الحفظ";

      Swal.fire({
        icon: "error",
        title: "فشل الحفظ!",
        text: errorMessage,
        confirmButtonText: "موافق",
        didOpen: () => {
          const container = document.querySelector(".swal2-container");
          container.style.zIndex = "99999";
        },
      });
    } finally {
      setFormSubmitted(false);
    }
  };

  const handleCancel = () => {
    setFormData({
      name: "",
      keywords: "",
      slug: "",
      meta_title: "",
      meta_icon: null,
      image: null,
      banner: null,
      description: "",
    });
    setErrors({});
    onClose();
  };
  const handleRemoveImage = () => {
    setFormData((prev) => ({ ...prev, logo: null }));
  };
  return (
    <Box
      sx={{
        p: 3,
        width: "100%",
        bgcolor: darkMode ? theme.palette.background.default : "background.paper",
        borderRadius: 2,
        boxShadow: 3,
        color: darkMode ? "white !important" : "inherit",
      }}
    >
      {/* Header */}
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
        <Typography variant="h5" fontWeight="bold">
          {formData.id ? "تعديل بيانات الماركة" : "إضافة ماركة جديدة"}
        </Typography>
      </Box>

      {/* Main Form */}

      <Box container spacing={3}>
        <Typography variant="subtitle1" gutterBottom fontWeight="bold">
          بيانات الماركة
        </Typography>
        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth error={!!errors.name} sx={{ mb: 2 }}>
            <TextField
              label="اسم الماركة*"
              name="name"
              value={formData.name}
              onChange={handleChange}
              error={!!errors.name}
              helperText={errors.name}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="كلمات تحسين محركات البحث"
              name="keywords"
              value={formData.keywords}
              onChange={handleChange}
            />
          </FormControl>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="الاسم في رابط URL"
              name="slug"
              value={formData.slug}
              onChange={handleChange}
            />
          </FormControl>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="عنوان علامة التبويب"
              name="meta_title"
              value={formData.meta_title}
              onChange={handleChange}
            />
          </FormControl>
        </Box>
        <Box display="flex" justifyContent="center" alignItems="center" gap={2}>
          <FormControl fullWidth sx={{ mb: 2 }}>
            <TextField
              label="الوصف"
              name="description"
              value={formData.description}
              onChange={handleChange}
            />
          </FormControl>
        </Box>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" gap={2}>
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            صورة الماركة
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleImageChange}
            sx={{ display: "none" }}
            id="image-upload"
            name="image"
          />
          <label htmlFor="image-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, color: "red" }}
            >
              تحميل الصورة
            </Button>
          </label>
          {formData.image && (
            <Avatar
              variant="square" // 👈 يجعل الصورة مربعة
              src={
                typeof formData.image === "string"
                  ? `https://back.al-balad.sa/uploads/brands/images/${formData.image}` // Existing image path
                  : URL.createObjectURL(formData.image) // New file upload
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="textSecondary" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
          <FormHelperText error>{errors.image}</FormHelperText>
        </Box>
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            ايقونة علامة التبويب
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleImageChange}
            sx={{ display: "none" }}
            id="meta-icon-upload"
            name="meta_icon"
          />
          <label htmlFor="meta-icon-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, color: "red" }}
            >
              تحميل الصورة
            </Button>
          </label>
          {formData.meta_icon && (
            <Avatar
              variant="square" // 👈 يجعل الصورة مربعة
              src={
                typeof formData.meta_icon === "string"
                  ? `https://back.al-balad.sa/uploads/brands/meta_icons/${formData.meta_icon}` // Existing image path
                  : URL.createObjectURL(formData.meta_icon) // New file upload
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="textSecondary" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
        </Box>
        <Box mt={3}>
          <Typography variant="subtitle1" gutterBottom fontWeight="bold">
            صورة غلاف الماركة
          </Typography>
          <Input
            type="file"
            inputProps={{ accept: "image/png, image/jpeg, image/gif,image/jpg" }}
            onChange={handleImageChange}
            sx={{ display: "none" }}
            id="banner-upload"
            name="banner"
          />
          <label htmlFor="banner-upload">
            <Button
              variant="outlined"
              component="span"
              startIcon={<AddIcon />}
              sx={{ width: 200, color: "red" }}
            >
              تحميل الصورة
            </Button>
          </label>
          {formData.banner && (
            <Avatar
              variant="square" // 👈 يجعل الصورة مربعة
              src={
                typeof formData.banner === "string"
                  ? `https://back.al-balad.sa/uploads/brands/banners/${formData.banner}` // Existing image path
                  : URL.createObjectURL(formData.banner) // New file upload
              }
              sx={{
                width: 100,
                height: 100,
                mt: 2,
                border: "2px solid #ddd",
              }}
            />
          )}
          <Typography variant="caption" color="textSecondary" display="block" mt={1}>
            (PNG, JPG, GIF فقط)
          </Typography>
        </Box>
      </Box>
      {/* Image Upload Section */}

      {/* Actions Section */}
      <Box mt={4} display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="body2" color="textSecondary">
          * الحقول المطلوبة
        </Typography>

        <Box display="flex" gap={2}>
          <Button variant="contained" color="error" onClick={handleCancel} sx={{ px: 4 }}>
            إلغاء
          </Button>
          <Button
            type="submit"
            variant="contained"
            color="primary"
            // disabled={Object.keys(errors).length > 0}
            sx={{ px: 4, color: "white !important" }}
            onClick={handleSubmit}
          >
            حفظ
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

export default AddBrandForm;
